<button
  class="select-button"
  [id]="buttonId"
  [disabled]="disabled"
  (click)="toggleDropDown()"
  type="button"
>
  <img src="{{ selectedItem.imgSrc }}" style="border-radius: 4px" />
</button>
<zaver-custom-select
  style="width: 220px"
  [showDropdown]="showDropDown"
  (dropdownClosed)="showDropDown = false"
  (itemSelected)="selected($event)"
  [items]="items"
  [selectedItem]="selectedItem"
></zaver-custom-select>
